/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdTabBarItemProps } from './type';
const props: TdTabBarItemProps = {
  /** 图标右上角提示信息 */
  badgeProps: {
    type: Object,
  },
  /** 图标名称。传入对象时透传至 Icon 组件 */
  icon: {
    type: null,
  },
  /** 二级菜单 */
  subTabBar: {
    type: Array,
  },
  /** 标识符 */
  value: {
    type: null,
  },
};

export default props;
